<div #mainDiv_ll_exam_sections_locations>
  <!-- Scrollable Question List -->
  <div *ngIf="bundle.showPanel && bundle.questionList.length > 0"
       class="question-list"
       [style.width.px]="bundle.panelW"
        [style.height.px]="bundle.panelH"
       style="overflow-y: auto; overflow-x: hidden; padding: 10px 0;">

    <div *ngFor="let q of bundle.questionList; let i = index" class="question-item">



      <!-- LOCATION lIST TABLE -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.LOCATION_TABLE_LIST_HTML | sanitizeHtml"></div>
        <span class="wordBtn" (click)="openLocationsModal(q)">Edit</span>
      </div>

      <!-- LOCATION OWNERSHIP TABLE -->
      <div class="company-html">
        <div class="company-content" [innerHTML]="q.LOCATION_TABLE_OWNERS_HTML | sanitizeHtml"></div>
        <!--<span class="wordBtn" (click)="openLocationsModal(q)">Edit</span>-->
      </div>

      <div class="question-divider"></div>
    </div>
  </div>






  <!-- ==================== LOCATIONS SELECTION MODAL ==================== -->
  <div *ngIf="showLocationModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1000;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 600px;
                max-height: 80vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.3);">
      <div style="padding: 16px; border-bottom: 1px solid #e0e0e0; display: flex;
                  justify-content: space-between; align-items: center; background: #f8f8f8;
                  border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <h3 style="margin: 0; font-size: 18px; color: #003399;">Exam Locations</h3>
        <button (click)="closeLocationsModal()"
                style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666; line-height: 1;">
          ×
        </button>
      </div>
      <div style="padding: 16px;">
        <div *ngFor="let loc of getLocationChoices()"
             style="display: flex; align-items: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; cursor: pointer;">
          <label style="display: flex; align-items: center; width: 100%; user-select: none;">
            <input type="checkbox"
                   [checked]="isLocationSelected(loc.LOCATIONID)"
                   (change)="toggleLocation(loc.LOCATIONID)"
                   style="margin-right: 16px; width: 18px; height: 18px; accent-color: #003399;" />
            <span style="flex: 1; font-size: 14px;">
              {{ loc.DISPLAY }}
            </span>
          </label>
        </div>
        <div *ngIf="getLocationChoices().length === 0"
             style="text-align: center; color: #999; padding: 40px 0;">
          No location choices available
        </div>
      </div>
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; text-align: right; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
        <button (click)="closeLocationsModal()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;
                       cursor: pointer; font-size: 14px;">
          Close
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== PROSPECT COMPANY DESCRIPTION EDITOR MODAL ==================== -->
  <div *ngIf="showDescriptionModal"
       style="position: fixed; inset: 0; background: rgba(0,0,0,0.6); z-index: 1200;
              display: flex; align-items: center; justify-content: center;">
    <div style="background: white; border-radius: 8px; width: 90%; max-width: 800px; max-height: 85vh;
                display: flex; flex-direction: column; box-shadow: 0 8px 30px rgba(0,0,0,0.4);">

      <!-- Header -->
      <div style="padding: 16px 20px; border-bottom: 1px solid #e0e0e0; background: #f8f8f8;
                  border-top-left-radius: 8px; border-top-right-radius: 8px; display: flex; justify-content: space-between; align-items: center;">
        <h3 style="margin: 0; color: #003399;">Edit Prospect Company Description</h3>
        <button (click)="closeDescriptionModal()"
                style="background: none; border: none; font-size: 28px; cursor: pointer; color: #666;">
          ×
        </button>
      </div>

      <!-- Editor Area -->
      <div style="flex: 1; padding: 20px; overflow: auto;">
        <div #descriptionEditor
             contenteditable="true"
             (input)="onDescriptionChange()"
             style="width: 100%; min-height: 350px; border: 1px solid #ccc; border-radius: 4px;
                    padding: 15px; font-size: 14px; line-height: 1.6; outline: none; background: white;">
        </div>
      </div>

      <!-- Footer -->
      <div style="padding: 16px; border-top: 1px solid #e0e0e0; background: #f8f8f8;
                  border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; text-align: right;">
        <button (click)="closeDescriptionModal()"
                style="margin-right: 12px; padding: 10px 20px; background: #666; color: white; border: none; border-radius: 4px;">
          Cancel
        </button>
        <button *ngIf="descriptionHasChanged" (click)="saveDescriptionChanges()"
                style="padding: 10px 24px; background: #003399; color: white; border: none; border-radius: 4px;">
          Save Changes
        </button>
      </div>
    </div>
  </div>

</div>

